module.exports = __webpack_public_path__ + "static/media/icn_user_default.57595693.png";